export default __webpack_public_path__ + "static/media/myorders.663ef225.svg";